export const educationData = [
  {
    id: 1,
    institution: "MASAI School, Bengaluru",
    course: "Full-Stack Web Development",
    startYear: "2021",
    endYear: "2022",
  },
  {
    id: 2,
    institution: "Oxford Software Institue, New Delhi",
    course: "E-Accounting",
    startYear: "2018",
    endYear: "2019",
  },
  {
    id: 3,
    institution: "University of Delhi, New Delhi",
    course: "BA Programme",
    startYear: "2014",
    endYear: "2017",
  },

  {
    id: 4,
    institution: " Kendriya Vidyalaya Tughlakabad, New Delhi",
    course: "Higher Secondary School",
    startYear: "2012",
    endYear: "2014",
  },
];
